import React, { useState } from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import { SvgIcon } from '@mui/material';
import { PortalNames } from "common/Portals";
import { Utils } from 'common/Utils';

export var SidebarData = {
    getItems: () => {
        var sidebarItems = [];
        
        sidebarItems.push({
            title: "Dashboard",
            icon: <DashboardOutlinedIcon />,
            link: `/${PortalNames.CollectionCompany.Path}/dashboard`,
            index: 1,
        });

        sidebarItems.push({
            title: "Important AXIM Messages",
            icon: <MessageOutlinedIcon />,
            link: `/${PortalNames.CollectionCompany.Path}/messages`,
            index: 2,
        });

        sidebarItems.push({
            title: "Files",
            icon: <DescriptionOutlinedIcon />,
            link: `/${PortalNames.CollectionCompany.Path}/files`,
            index: 5,
        });
        sidebarItems.push({
            title: "Uploads",
            icon: <PublishOutlinedIcon />,
            link: `/${PortalNames.CollectionCompany.Path}/uploads`,
            index: 8,
        });

        sidebarItems = sidebarItems.sort((a, b) => a.index - b.index);

        return sidebarItems;
    }
}
